import { createAction, createAsyncAction } from 'typesafe-actions';
import { ViewsModels } from './types';

export const FETCH_RELATED_PRODUCTS = createAsyncAction(
  'product/FETCH_RELATED_PRODUCTS/request',
  'product/FETCH_RELATED_PRODUCTS/success',
  'product/FETCH_RELATED_PRODUCTS/failure',
  'product/FETCH_RELATED_PRODUCTS/cancel',
)<void, ViewsModels.RelatedProducts, Error, void>();

export const RESET_RELATED_PRODUCTS = createAction('product/RESET_RELATED_PRODUCTS')();
